import { useEffect, useState } from "react";
import logo from "../assets/images/icon.png";
import { Link, usePage } from "@inertiajs/react";
import { isMobile } from "react-device-detect";

const ACCENT = "#4096ff";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const url = usePage();

  const routeActive = (route) => url.url === route;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isLight = scrolled;
  
  const navPadding = isMobile
    ? isLight ? "8px 16px" : "12px 20px"
    : isLight ? "12px 32px" : "15px 28px";

  const ulGap = isMobile
    ? isLight ? 10 : 14
    : isLight ? 18 : 24;

  const imgWidth = isMobile
    ? isLight ? 24 : 32
    : isLight ? 28 : 38;

  const linkFontSize = isMobile
    ? isLight ? 11 : 12
    : isLight ? 13 : 14;

  const linkStyle = (active) => ({
    color: active ? ACCENT : "inherit",
    textDecoration: "none",
    fontSize: linkFontSize,
    fontWeight: 600,
    fontFamily: "'Quicksand', sans-serif",
    transition: "all 0.3s ease",
    opacity: active ? 1 : 0.85,
  });

  return (
    <nav
      style={{
        width: "calc(100% - 32px)",
        maxWidth: 400,
        position: "fixed",
        top: isLight ? 12 : 24,
        left: "50%",
        transform: "translateX(-50%)", 
        zIndex: 999,
        borderRadius: isLight ? 16 : 20,
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        backdropFilter: "blur(16px) saturate(1.4)",
        WebkitBackdropFilter: "blur(16px) saturate(1.4)",
        background: isLight
          ? "rgba(255, 255, 255, 0.85)"
          : "rgba(0, 0, 0, 0.35)",
        border: isLight
          ? "1px solid rgba(255, 255, 255, 0.7)"
          : "1px solid rgba(255, 255, 255, 0.15)",
        boxShadow: isLight
          ? "0 8px 32px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.7)"
          : "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
        color: isLight ? "#1a2332" : "#ffffffd9",
        padding: navPadding,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: isLight ? 4 : 8,
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link href="/" style={{ textDecoration: "none" }}>
            <img
              src={logo}
              alt="Logo"
              style={{
                width: imgWidth,
                height: "auto",
                borderRadius: "100%",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: isLight
                  ? `0 3px 12px ${ACCENT}20`
                  : `0 6px 24px ${ACCENT}30`,
              }}
            />
          </Link>
        </div>

        <ul
          style={{
            display: "flex",
            flexDirection: "row",
            listStyleType: "none",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            padding: 0,
            gap: ulGap,
            flexWrap: isMobile ? "wrap" : "nowrap",
          }}
        >
          <li>
            <Link style={linkStyle(routeActive("/"))} href={"/"}>
              Home
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/about"))} href={"/about"}>
              About
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/product"))} href={"/product"}>
              Product
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/contact"))} href={"/contact"}>
              Contact
            </Link>
          </li>
          <li>
            <Link style={linkStyle(routeActive("/galeri"))} href={"/galeri"}>
              Galeri
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}